<template>
  <div class="page_container">
    <div class="content-box">
        <div>
            <woot-button
                color-scheme="success"
                class-names="button--fixed-right-top"
                icon="add-circle"
                :isDisabled="isExporting"
                :isLoading="isExporting"
                @click="onExportData"
            >
            {{$t('CAMPAIGN.CAMPAIGN_FORMS.TABLE.ACTIONS.EXPORT_BTN')}}
            </woot-button>
        </div>
        <!-- form title  -->
        <h3 v-if="meta.form_title" class="block-title text_center mb_20">
            {{meta.form_title}}
        </h3>
        <div class="search_container mb_16">
            <SearchInput
            :placeholder="$t('CAMPAIGN.FILTERS.SEARCH_PLACEHOLDER')"
            v-model="searchValue"
            @search="onSearch"
            />
        </div>
        <!-- <section class="campaing_filters">
            <div class="campaing_filter">
            <p class="input_label">{{$t('ORDER.LIST_TABLE.DATE.LABEL')}}</p>
            <date-range-picker
                :confirm-text="$t('ORDER.LIST_TABLE.DATE_SELECT_CONFIRM_BTN')"
                :placeholder="$t('ORDER.LIST_TABLE.DATE.PLACEHOLDER')"
                class="font_normal order_start_date"
                :value="dateRange"
                @change="handleDateChange"
                :disabledDate="disableFilterDate"
            />
            </div>
            <div class="campaing_filter">
            <p class="input_label">{{$t('CAMPAIGN.FILTERS.STATUS')}}</p>
            <multiselect
                v-model="selectedStatus"
                :options="statusList"
                class="small-12 font_normal"
                track-by="id"
                label="title"
                :multiple="false"
                :close-on-select="true"
                :clear-on-select="false"
                :hide-selected="true"
                :placeholder="$t('CAMPAIGN.FILTERS.STATUS_PLACEHOLDER')"
                selected-label
                :select-label="''"
                :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
                @select="applyFilterByStatuses($event)"
            />
            </div>
            <div class="campaing_filter">
            <p class="input_label">{{$t('CAMPAIGN.FILTERS.SORT_BY')}}</p>
            <multiselect
                v-model="sortBy"
                :options="sortByList"
                class="small-12 font_normal"
                track-by="id"
                label="title"
                :multiple="false"
                :close-on-select="true"
                :clear-on-select="false"
                :hide-selected="true"
                :placeholder="$t('CAMPAIGN.FILTERS.SORTBY_PLACEHOLDER')"
                selected-label
                :select-label="''"
                :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
                @select="applyFilterBySortBy($event)"
            />
            </div>

        </section> -->

        <ResponderTable
            :cols="cols"
            :isLoading="uiFlags.isFetching"
            :records="responders"
            :showEmptyResult="!uiFlags.isFetching && !responders.length"
        />
        <div>
            <table-footer
                :on-page-change="onPageChange"
                :current-page="Number(meta.current_page)"
                :total-count="meta.count"
                />
        </div>

    </div>
  </div>
</template>

<script>
import TableFooter from 'dashboard/components/widgets/TableFooter';
import alertMixin from 'shared/mixins/alertMixin';
import { mapGetters } from 'vuex';
import helperMixin from 'shared/mixins/helperMixin';
// import moment from "moment";
import ResponderTable from "./ResponderTable.vue";
import CampaignFormsAPI from "dashboard/api/campaign_forms.js";
// import DateRangePicker from "components/ui/DateRangePicker.vue"
import moment from "moment";
import SearchInput from 'dashboard/components/ui/SearchInput.vue'


export default {
    components:{
        TableFooter,
        ResponderTable,
        // DateRangePicker,
        SearchInput,
    },
    mixins:[alertMixin,helperMixin],
    data(){
        // const endDate = new Date(); // Current date
        // const startDate = new Date();
        // startDate.setMonth(startDate.getMonth() - 1); // One month ago

        return {
            // dateRange: [startDate,endDate],
            searchValue:'',
            // selectedStatus: null,
            // sortBy:null,

            isExporting:false,
        }
    },
    computed:{
        ...mapGetters({
            currentUser: 'getCurrentUser',
            uiFlags: "campaigns/getUIFlagsFormResponders",
            meta: "campaigns/getFormResponderMeta",
            responders: "campaigns/getFormResponders",
        }),
        paginationCompute(){
            const totalPages = Math.ceil(this.meta.count / this.meta.pageSize);
            const isLastPage = this.meta.current_page >= totalPages;
            const currentCount = Math.min(this.meta.current_page * this.meta.pageSize, this.meta.count);
            // const btnText = `Load More Orders (${currentCount}/${this.meta.count})`;
            const btnText = `${this.$t('CAMPAIGN.LLM_CHATBOT.REPORT.LOAD_MORE_BTN')} (${currentCount}/${this.meta.count})`;

            return{
                isLastPage,
                btnText,
            }
        },
        cols(){
            const cols = [
                { key: 'respondent_email', name: 'respondent_email', visible: true, type: 'default' },
                { key: 'respondent_phone', name: 'respondent_phone', visible: true, type: 'default' },
            ]

            return cols;
        },
    },
    activated() {
    // When revisiting the route (with <keep-alive>)
        this.getRecordList({
            page: 1,
            // start_date: this.formatStartEndDate(this.dateRange[0],this.dateRange[1]).start_date,
            // end_date: this.formatStartEndDate(this.dateRange[0],this.dateRange[1]).end_date,
        });
    },
     deactivated() {
        // const endDate = new Date(); // Current date
        // const startDate = new Date();
        // startDate.setMonth(startDate.getMonth() - 1); // One month ago
        // this.dateRange = [startDate,endDate];
    },
    methods:{
        async getRecordList(newQuery={}){
            try {
                console.log();
                const defautQuery = {
                    page: this.meta.current_page,
                    page_size:  this.meta.page_size,
                    q: this.searchValue,
                    // status: this.selectedStatus?.id,
                    // order: this.sortBy?.order,
                    // direction: this.sortBy?.direction,
                    // start_date: this.formatStartEndDate(this.dateRange[0],this.dateRange[1]).start_date,
                    // end_date: this.formatStartEndDate(this.dateRange[0],this.dateRange[1]).end_date,
                    ...newQuery,
                }
                this.$store.dispatch("campaigns/fetchFormResponders",{
                    form_id: this.$route.params.campaign_form_id,
                query:this.cleanObject(defautQuery)});
            } catch (error) {
                console.log(error);
            }
        },
        // async handleDateChange(dateRange) {
        //     this.dateRange = dateRange;
        //     const date = this.formatStartEndDate(dateRange[0],dateRange[1]);
        //     this.getRecordList({
        //         page: 1,
        //         start_date: date.start_date,
        //         end_date: date.end_date,
        //     })
        // },
        // disableFilterDate(date, currentValues) {
        //     return false // never disable any field
        //     // const today = moment();
        //     // const monthAgo = 3;
        //     // const nMonthsAgo = moment().subtract(monthAgo, 'months');  // disable before 3 months
        //     // const targetDate = moment(date);
        //     // return targetDate.isAfter(today, 'day') || targetDate.isBefore(nMonthsAgo, 'day');
        // },
        onPageChange(page){
            this.getRecordList({page,})
        },
        onSearch(value){
            this.getRecordList({q:value,page:1});
        },
        async onExportData(){
           try {
            this.isExporting = true;
            const response = await CampaignFormsAPI.exportFormRespondersById(this.$route.params.campaign_form_id);

            // Create a blob from the response data
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

            // Get filename from content-disposition header if available
            const disposition = response.headers['content-disposition'];
            let filename = 'file.xlsx'; // default fallback
            if (disposition && disposition.indexOf('filename=') !== -1) {
                const filenameMatch = disposition.match(/filename\*?=([^;]+)/);
                if (filenameMatch != null && filenameMatch.length > 1) {
                filename = filenameMatch[1].trim();
                // filename might be quoted or URI encoded
                filename = filename.replace(/['"]/g, ''); // remove quotes
                try {
                    filename = decodeURIComponent(filename);
                } catch (e) {}
                }
            }

            // Create a download link and click it
            const link = document.createElement('a');
            const url = window.URL.createObjectURL(blob);
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();

            // Cleanup
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
            } catch (error) {
                console.log(error);
                this.showErrAlert(error,this.$t('CAMPAIGN.NETWORK_ERR.FETCH_ERR'));
            }finally{
                this.isExporting = false;
            }
        },
    },
}
</script>


<style scoped lang="scss">
.search_container{
  max-width: 280px;
}
</style>